/* eslint-disable no-nested-ternary */
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CheckBoxMC from "../../components/CheckBoxMC";
import ButtonMC from "../../components/ButtonMC";
import RetailerModel from '../../../components/Retailers/RetailerModel';
import ProductModel from '../../../components/Products/ProductModel';

const TabsComponentMC = ({
  getSelectedTab, toggleTabs, selectedItems, allItems, setSelectedItems, hiddeActions = true
}) => {
  const navigate = useNavigate();
  const { t: tCommon } = useTranslation('Common');
  const { t } = useTranslation('Products');

  const handleChange = (e) => {
    if (e.target.checked) {
      setSelectedItems([...allItems]);
    } else {
      setSelectedItems([]);
    }
  };

  const label = selectedItems.length === 1
    ? `1 ${t('selected')}`
    : `${selectedItems.length} ${t('more_selected')}`;

  const syncWithMia = () => {
    if (window.confirm(t('mia.sync_confirm'))) {
      const product_web_ids = selectedItems.map((item) => item.web_id )
      RetailerModel.miaSyncSelectedProducts({ product_web_ids: product_web_ids })
        .then(() => {
          showtoast(t('mia.sync_started'));
        })
        .catch((error) => {
          showtoast(error.message || t('mia.sync_error'));
        });
    }
    return false;
  }

  const handleDeleteSeleted = () => {

    if (window.confirm(t('delete_selected_products.confirm'))) {
      const product_ids = selectedItems.map((item) => item.id )
      ProductModel.deleteSelected({ product_ids: product_ids })
        .then(() => {
          showtoast(t('delete_selected_products.success'));
          navigate(0)
        })
        .catch((error) => {
          showtoast(error.message || t('alerts.error'));
        });
    }
    return false;
  }

  return (
    <>
      <div className="tw-flex tw-gap-6">
        <div className={`tw-px-6 tw-py-1 tw-cursor-pointer ${getSelectedTab('all')}`} onClick={() => toggleTabs('all')}>
          {t('tabs.all_products')}
        </div>
        <div className={`tw-px-6 tw-py-1 tw-cursor-pointer ${getSelectedTab('active')}`} onClick={() => toggleTabs('active')}>
          {t('tabs.actives')}
        </div>
        <div className={`tw-px-6 tw-py-1 tw-cursor-pointer ${getSelectedTab('inactive')}`} onClick={() => toggleTabs('inactive')}>
          {t('tabs.inactives')}
        </div>
      </div>

      {!hiddeActions && (
        <div className="tw-flex tw-items-center tw-px-4 tw-py-4 tw-gap-8 tw-border tw-border-gray-200">
          <CheckBoxMC
            checked={selectedItems.length === allItems.length}
            onChange={handleChange}
            className="tw-w-4 tw-h-4"
          />
          <div><span className="tw-text-gray-950">{label}</span></div>
          <ButtonMC
            text={t('sync_with_mia')}
            variant="GRAY"
            icon="new-bot"
            iconClassName="tw-flex tw-items-center tw-justify-center"
            onClick={syncWithMia}
            outlined
          />
          <ButtonMC
            text={tCommon('actions.delete')}
            variant="GRAY"
            icon="trash-2-outline"
            iconClassName="tw-flex tw-items-center tw-justify-center"
            onClick={handleDeleteSeleted}
            outlined
          />
        </div>
      )}
    </>
  );
};

export default TabsComponentMC;
